import * as React from 'react'
import type { ViewablePageReport } from '../../../../shared/domain/viewableReports/types.no-deps'
import { ViewReport } from './ViewReport'
import type { ReportClientId } from '../../../../shared/domain/reports'
import { doNothing } from '../../../../shared/lib/functional/function.no-deps'
import type { CommonDeps } from '../../base/CommonDeps'
import type { RenderCachedImage } from '../../image/WithCachedImage'

interface Props {
    reportClientIds: ReportClientId[]
    lookup: Record<ReportClientId, ViewablePageReport>
    deps: CommonDeps
    downloadFile: (url: string, name: string, mimeType: string) => Promise<void>
    renderCachedImage: RenderCachedImage
}

export function ViewReportsWithTitles(props: Props) {
    const { reportClientIds, lookup, deps, downloadFile, renderCachedImage } = props

    const renderTitle = (title: string) => {
        return <div className="AppCore__report__ViewReportsWithTitle_title">{title}</div>
    }

    return (
        <div className="AppCore__report__ViewReportsWithTitles">
            <ul>
                {reportClientIds.map((reportId) => {
                    const report: ViewablePageReport = lookup[reportId]
                    return (
                        <li key={reportId}>
                            {reportClientIds.length > 1 && renderTitle(report.title)}
                            <ViewReport
                                deps={deps}
                                onOpenFile={downloadFile}
                                onReportPostClick={doNothing}
                                photoUrls={report.photoUrls}
                                renderCachedImage={renderCachedImage}
                                report={report}
                                reportDetails={report.reportDetails}
                                unitTypes={report.unitTypesInAnswers}
                                units={report.unitsInAnswers}
                                allowImageZoom={true}
                            />
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
